var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ai-chat',{attrs:{"mode":"chatTest","data":_vm.data,"res-id":_vm.resId,"initial-virtual-key-id":_vm.initialVirtualKeyId,"initial-virtual-key":_vm.initialVirtualKey,"initial-chat-model":_vm.initialChatModel}})
}
var staticRenderFns = []

export { render, staticRenderFns }